<template>
  <van-dialog
    :show="props.isShowHelp"
    confirm-button-text="收到了解～"
    :before-close="closeHelp"
    teleport="#app"
    style="text-align: center"
  >
    <p>课群ID为邀请地址中纯数字的号码</p>
    <i class="iSize"
      >...XXX/<b style="color: red">123XXXX</b>/index#invitation=ABCDEFGH</i
    ><br />
    <i class="iSize"
      >...group/<b style="color: red">123XXXX</b>#invitation=ABCDEFGH</i
    >
    <br />
    <h5>
      若只有邀请码(由字母数字组成)<br />那么请打开易班对应课群随后复制其地址<br />在地址中即可看见课群ID
    </h5>
  </van-dialog>
</template>
<script>
import { Dialog } from "vant";
export default {
  props: {
    isShowHelp: Boolean,
  },
  components: {
    [Dialog.Component.name]: Dialog.Component,
  },
  emits: ["update:isShowHelp"],
  setup(props, { emit }) {
    // 关闭弹窗事务
    const closeHelp = () => {
      emit("update:isShowHelp", false);
      return true;
    };
    return { props, closeHelp };
  },
};
</script>
<style>
.iSize {
  font-size: 10px;
}
</style>
